module.exports = __webpack_public_path__ + "img/tab_music_select_icon.dbc34c6e.svg";